import { render, staticRenderFns } from "./ContactNotificationEditPopup.vue?vue&type=template&id=28971f4f&"
import script from "./ContactNotificationEditPopup.vue?vue&type=script&lang=js&"
export * from "./ContactNotificationEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports